export default [
    {
        path: 'confirmacao-consulta',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-confirmacao-consulta' */
            '@/views/ambulatorio/confirmacao-consulta/Index'
        ),
        redirect: 'confirmacao-consulta/index',
        children: [
            {
                name: 'ambulatorio-confirmacao-consulta-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-confirmacao-consulta' */
                    '@/views/ambulatorio/confirmacao-consulta/List.vue'
                ),
            },
        ],
    },
]
